import React from 'react'
import PropTypes from 'prop-types'
import ReactSummernote from 'react-summernote'
import axios from 'axios'
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.css'
import 'react-summernote/dist/react-summernote.css'
import EquationBox from '../EquationBox'
import UploadVideoBox from '../UploadVideoBox'
import UploadAttachment from '../UploadAttachment'
import * as buttons from './summernote_buttons'
import { API_HOST } from '../../consts'
import { standardizeClipboardData } from '../../utils/html'

window.jQuery = $
require('bootstrap')
require('react-summernote/lang/summernote-pt-BR')


const customCSS = `
  .note-editable ul {
    list-style-type: disc ;
    margin-left: 20px;
  }

`;
class RawInputSummernote extends React.Component {

  constructor(props) {
    super(props)
    this.onPaste = this.onPaste.bind(this)
  }

  defaultFont = "Open Sans"
  defaultFontSize = 14

  insertTableMaxSize = {
    col: 20,
    row: 30
  }

  state = {
    openModal: null,
  }

  componentDidMount() {
    const style = document.createElement('style');
    style.innerHTML = customCSS;
    document.head.insertAdjacentElement('beforeend', style);
  }

  onImageUpload(images, insertImage) {
    for (let i = 0; i < images.length; i += 1) {
      const reader = new FileReader()
      reader.onloadend = () => {
        insertImage(reader.result)
      }
      reader.readAsDataURL(images[i])
    }
  }

  convertLatexToImage(latex) {
    return axios.get(`${API_HOST}/uploads/tex2img`, {
      params: {
        cht: 'tx',
        chl: latex,
      },
    })
  }

  onPaste(e) {
    let clipboardData = ((e.originalEvent || e).clipboardData || window.clipboardData)
    e.preventDefault()
    let contentToPaste = standardizeClipboardData(clipboardData,
      this.defaultFont,
      this.defaultFontSize)
    setTimeout(function () {
      document.execCommand('insertHtml', false, contentToPaste)
    }, 10)
  }

  handleEquationBoxOpened = (context) => {
    this.setState({
      openModal: 'equationBox',
      addEquationToContent: (formula) => {
        this.convertLatexToImage(formula)
          .then((response) => {
            const base64 = response.data
            const node = document.createElement('img')
            node.classList = ['formula']
            node.setAttribute('data-formula', formula)
            node.src = base64
            context.invoke('editor.restoreRange')
            context.invoke('editor.insertNode', node)
          })
        this.setState({ openModal: null })
      },
    })
  }

  handleUploadVideoOpened = (context) => {
    this.setState({
      openModal: 'uploadVideoBox',
      addVideoToContent: (videoNode) => {
        context.invoke('editor.restoreRange')
        context.invoke('editor.insertNode', videoNode)
        this.setState({ openModal: null })
      }
    })

  }

  handleUploadAttachmentOpened = (context) => {
    this.setState({
      openModal: 'UploadAttachment',
      addAttachmentToContent: (attachmentNode) => {
        context.invoke('editor.restoreRange')
        context.invoke('editor.insertNode', attachmentNode)
        this.setState({ openModal: null })
      }
    })

  }

  render() {
    const { value, onChange, disabled, ...rest } = this.props
    const { openModal, addEquationToContent, addVideoToContent, addAttachmentToContent } = this.state
    return (
      <React.Fragment>
        <ReactSummernote
          className="text-options"
          onChange={onChange}
          disabled={disabled}
          value={value || ''}
          onImageUpload={this.onImageUpload}
          onPaste={this.onPaste}
          options={{
            buttons: {
              math: buttons.EquationButton(this.handleEquationBoxOpened),
              uploadVideo: buttons.VideoButton(this.handleUploadVideoOpened),
              imageMarginTop: buttons.UpImageButton,
              imageMarginBottom: buttons.DownImageButton,
              increaseBothMarginsButton: buttons.IncreaseBothMarginsButton,
              decreaseBothMarginsButton: buttons.DecreaseBothMarginsButton,
              resetMarginButton: buttons.ResetMarginButton,
              uploadAttachment: buttons.AttachmentButton(this.handleUploadAttachmentOpened),
            },
            fontSize: this.defaultFontSize,
            fontNames: [this.defaultFont, 'Arial', 'Courier New', 'Helvetica', 'Verdana'],
            lang: 'pt-BR',
            height: 80,
            dialogsInBody: true,
            disableResize: true,
            resize: false,
            insertTableMaxSize: this.insertTableMaxSize,
            toolbar: [
              ['fontname', ['fontname']],
              ['fontsize', ['fontsize']],
              ['font', ['bold', 'underline', 'italic', 'clear']],
              ['color', ['color']],
              ['font', ['strikethrough', 'superscript', 'subscript']],
              ['para', ['ul', 'ol', 'paragraph']],
              ['table', ['table']],
              ['insert', ['link', 'picture']],
              ['view', ['codeview']],
              ['custom', ['math']],
              ['custom', ['uploadVideo']],
              ['custom', ['uploadAttachment']],
            ],
            popover: {
              image: [
                ['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],
                ['float', ['floatLeft', 'floatRight', 'floatNone']],
                [
                  'adjustMargin',
                  [
                    'imageMarginTop',
                    'imageMarginBottom',
                    'increaseBothMarginsButton',
                    'decreaseBothMarginsButton',
                    'resetMarginButton',
                  ],
                ],
                ['remove', ['removeMedia']],
              ],
            },
            ...rest,
          }}
        />
        <EquationBox
          isOpen={openModal === 'equationBox'}
          onClick={addEquationToContent}
          onClose={() => this.setState({ openModal: null })}
        />
        <UploadVideoBox
          isOpen={openModal === 'uploadVideoBox'}
          onClick={addVideoToContent}
          onClose={() => this.setState({ openModal: null })}
        />
        <UploadAttachment
          isOpen={openModal === 'UploadAttachment'}
          onClick={addAttachmentToContent}
          onClose={() => this.setState({ openModal: null })}
        />
      </React.Fragment>
    )
  }
}

RawInputSummernote.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

RawInputSummernote.defaultProps = {
  value: '',
}

export default RawInputSummernote
